import { render } from "./ModalNuovoOrdineAppuntamento.vue?vue&type=template&id=3760b478&scoped=true"
import script from "./ModalNuovoOrdineAppuntamento.vue?vue&type=script&lang=js"
export * from "./ModalNuovoOrdineAppuntamento.vue?vue&type=script&lang=js"

import "./ModalNuovoOrdineAppuntamento.vue?vue&type=style&index=0&id=3760b478&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_gm-system_1770887991853013682/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3760b478"]])

export default __exports__